
export const inventoryTypes = [
    {
        id: 0,
        label: "None"
    },
    {
        id: 1,
        label: "Tire"
    },
    {
        id: 2,
        label: "Wheel"
    }
]